/**
 * BillingToggle Component
 * Segmented control for switching between monthly and yearly billing
 *
 * Pattern: Mobile-first segmented control (similar to SessionPreferences meal timing)
 * Design: Two-button toggle with active state highlighting and savings badge
 */

import { Badge } from '@talktoast/ui'

interface BillingToggleProps {
  value: 'monthly' | 'yearly'
  onChange: (value: 'monthly' | 'yearly') => void
  savings?: number
}

export function BillingToggle({ value, onChange, savings = 17 }: BillingToggleProps) {
  return (
    <div className="flex items-center justify-center mb-6">
      <div className="inline-flex items-center gap-2 bg-gray-100 rounded-lg p-1">
        {/* Monthly Option */}
        <button
          onClick={() => onChange('monthly')}
          className={`
            px-6 py-2 rounded-md text-sm font-semibold transition-all min-h-[44px]
            ${value === 'monthly'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
            }
          `}
        >
          Monthly
        </button>

        {/* Yearly Option */}
        <button
          onClick={() => onChange('yearly')}
          className={`
            relative px-6 py-2 rounded-md text-sm font-semibold transition-all min-h-[44px]
            ${value === 'yearly'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
            }
          `}
        >
          Yearly
          {savings > 0 && (
            <Badge
              variant="success"
              size="sm"
              className="absolute -top-2 -right-2 bg-avocado-green text-white text-xs px-2 py-0.5"
            >
              Save {savings}%
            </Badge>
          )}
        </button>
      </div>
    </div>
  )
}
